/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var WorkerJobType;
(function (WorkerJobType) {
    WorkerJobType["PARENT"] = "PARENT";
    WorkerJobType["FORECAST"] = "FORECAST";
})(WorkerJobType || (WorkerJobType = {}));
export function WorkerJobTypeFromJSON(json) {
    return WorkerJobTypeFromJSONTyped(json, false);
}
export function WorkerJobTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function WorkerJobTypeToJSON(value) {
    return value;
}
